import React from 'react';
import classnames from 'classnames';
import styles from './styles.mod.scss';
import { TextButton } from 'scy/buttons';
import { H4, H5 } from 'scy/text';
import { accent, uppercase } from 'scy/text/styles.mod.scss';
import { flex } from 'scy/flex.mod.scss';

function Tabs({ children }) {
  return <div className={flex}>{children}</div>;
}

function Tab({ heading, subheading, isSelected, onClick }) {
  const tabClass = classnames(styles.tab, {
    [styles.selectedTab]: isSelected
  });

  const textClass = classnames(uppercase, {
    [accent]: isSelected
  });

  return (
    <TextButton
      noUnderline
      type="button"
      className={tabClass}
      onClick={onClick}
    >
      <H4 className={textClass}>{heading}</H4>
      <H5 className={textClass}>{subheading}</H5>
    </TextButton>
  );
}

export { Tabs, Tab };
